export const CELER_TRANSFER_STATUS = {
    XS_UNKNOWN: 'XS_UNKNOWN',
    XS_WAITING_FOR_SGN_CONFIRMATION: 'XS_WAITING_FOR_SGN_CONFIRMATION',
    XS_WAITING_FOR_FUND_RELEASE: 'XS_WAITING_FOR_FUND_RELEASE',
    XS_COMPLETED: 'XS_COMPLETED',
    XS_TO_BE_REFUND: 'XS_TO_BE_REFUND',
    XS_REFUND_TO_BE_CONFIRMED: 'XS_REFUND_TO_BE_CONFIRMED',
    XS_REFUNDED: 'XS_REFUNDED'
} as const;

export type CelerTransferStatus =
    (typeof CELER_TRANSFER_STATUS)[keyof typeof CELER_TRANSFER_STATUS];
